export function WorkerModel(data) {
    this.id = data.workerId;

    this.name = data.fullName;
    this.filial = data.filial;

    const categories = data.category || {};

    this.positions = [];

    if (data.postCategorySpecialty) {
        this.positions = Object.entries(data.postCategorySpecialty).map(([key, name]) => ({
            id: key,
            name,
            category: categories[key],
        }));
    }

    this.schedule = data.schedule;
    this.status = data.workerStatus;
    this.characteristic = data.characteristic;
    this.citizenship = data.citizenship;
    this.lawStatus = data.lawStatus;
    this.employmentStatus = data.employmentStatus;

    this.account = data.personalAccount || 0;
}
